var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-left" }, [
    _vm.componentReady
      ? _c("div", [
          _c("h5", {
            domProps: {
              textContent: _vm._s(
                _vm.t("forms.new_contractor_numemployees.IC_0000")
              ),
            },
          }),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "panel" }, [
            !_vm.isAfricaCountry
              ? _c("p", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.t("forms.new_contractor_numemployees.IC_0001")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isAfricaCountry
              ? _c("p", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.t("forms.new_contractor_numemployees2.IC_0001")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          !_vm.isAfricaCountry
            ? _c("div", [
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "14" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "14"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "14"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType100")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "15" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "15"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "15"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType101")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "16" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "16"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "16"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType102")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "17" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "17"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "17"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType103")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "18" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "18"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "18"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType104")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "19" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "19"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "19"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType105")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "20" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "20"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "20"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType106")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "21" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "21"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "21"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType107")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "22" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "22"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "22"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType108")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "23" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "23"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "23"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType109")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "24" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "24"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "24"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.offices_employees_choice.MemberType110")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isAfricaCountry
            ? _c("div", [
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "6" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "6"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "6"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.new_contractor_numemployees2.IC_0003")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "7" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "7"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "7"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.new_contractor_numemployees2.IC_0004")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "8" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "8"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "8"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.new_contractor_numemployees2.IC_0005")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "9" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "9"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "9"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.new_contractor_numemployees2.IC_0006")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "10" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "10"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "10"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.new_contractor_numemployees2.IC_0007")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "11" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "11"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "11"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.new_contractor_numemployees2.IC_0008")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "12" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "12"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "12"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.new_contractor_numemployees2.IC_0009")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localData.memberInfo.NumEmpl,
                          expression: "localData.memberInfo.NumEmpl",
                        },
                      ],
                      attrs: { type: "radio", value: "13" },
                      domProps: {
                        checked: _vm._q(_vm.localData.memberInfo.NumEmpl, "13"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.localData.memberInfo,
                            "NumEmpl",
                            "13"
                          )
                        },
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.t("forms.new_contractor_numemployees2.IC_0010")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _vm.displayError
              ? _c("small", {
                  staticClass: "error",
                  domProps: {
                    textContent: _vm._s(
                      "You must enter a peak number of employees"
                    ),
                  },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row", staticStyle: { "margin-top": "30px" } },
            [
              _c("div", { staticClass: "columns small-12 text-center" }, [
                _c("button", {
                  staticClass: "tiny navBtn",
                  domProps: {
                    textContent: _vm._s(
                      _vm.t("forms.new_blank_reference_member.IC_0024")
                    ),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.checkComplete()
                    },
                  },
                }),
              ]),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.componentReady
      ? _c("div", [_c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" })])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }